export const getPlanBackground = (plan) => {
    switch (plan.toLowerCase()) {
        case 'free':
            return '#c2c2c2';
        case 'standard':
        case 'premium':
            return '#15bbc6';
        case 'enterprise':
            return '#00c473';
        case 'ai':
        case 'intelligence':
            return 'linear-gradient(92.56deg, rgb(97, 244, 222) -32.55%, rgb(110, 120, 255) 107.96%)'
            // return '#69a7f3';
        default:
            return '#FFFFFF';
    }
}

export const deepEqual = (a: any, b: any): boolean => {
    if (a === b) return true;
    if (typeof a !== 'object' || a === null ||
        typeof b !== 'object' || b === null) return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
        if (Array.isArray(a[key]) && Array.isArray(b[key])) {
            if (a[key].length !== b[key].length) return false;
            for (let i = 0; i < a[key].length; i++) {
                if (!deepEqual(a[key][i], b[key][i])) return false;
            }
        } else if (!deepEqual(a[key], b[key])) {
            return false;
        }
    }

    return true;
};


/**
 * KST 달력일(payment 가 내려주는 `YYYY-MM-DD` 문자열)은 정의상 타임존 변환 대상이 아니므로
 * 변환 없이 앞 10자리를 그대로 표시한다. (시각 timestamp 는 별도 포매터를 쓸 것)
 */
export const formatCalendarDate = (val?: string | number | null): string => (val ? String(val).slice(0, 10) : '-');

export const formatBytes = (value: number | string | null | undefined): string => {
    if (!value) return "0";
    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(num) || num < 0) return '-';

    if (num === 0) return '0 B';

    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(num) / Math.log(k));

    const formatted = parseFloat((num / Math.pow(k, i)).toFixed(2));
    return `${formatted} ${sizes[i]}`;
}